<template>
  <div>
    <basic-container>
      <div>
        <el-form
          ref="form"
          :model="projectServiceForm"
        >
          <el-form-item
            label="工程项目名称"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-select
                v-model="projectServiceForm.projectItem"
                placeholder="请选择工程项目名称"
                width="200"
                disabled
                @change="chooseProjectItem"
                value-key="id"
              >
                <el-option
                  v-for="item in projectItems"
                  :key="item.id"
                  :label="item.name"
                  :value='item'
                ></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            label="预约人姓名"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-input
                v-model="projectServiceForm.reservationName"
                placeholder="请选择预约人姓名"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="预约人电话"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-input
                v-model="projectServiceForm.reservationMobile"
                placeholder="请选择预约人电话"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="服务地址"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <!-- <avue-map v-model="point"></avue-map> -->
              <el-button disabled>选择坐标</el-button>
            </div>
          </el-form-item>
          <el-form-item
            label="详细地址"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-input
                v-model="point.address"
                placeholder="请输入详细地址"
              >
              </el-input>
            </div>
          </el-form-item>
          <el-form-item
            label="服务时间"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-date-picker
                v-model="projectServiceForm.serviceTime"
                type="datetime"
                value-format="timestamp"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="服务预约配置">
            <div>
              <!-- {{dataList}} -->
              <el-table
                :data="dataList"
                border
              >
                <el-table-column
                  prop="serviceItemName"
                  align="center"
                  label="工程阶段名称"
                >
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.serviceItemName"
                      disabled
                    >
                    </el-input>
                  </template>

                </el-table-column>
                <el-table-column
                  prop="serviceTime"
                  align="center"
                  label="工程开始时间"
                >
                  <template slot-scope="scope">
                    <el-date-picker
                      :disabled="scope.row.disabled"
                      v-model="scope.row.serviceTime"
                      @change="blurKey"
                      type="datetime"
                      placeholder="选择工程开始时间"
                      value-format="timestamp"
                      default-time="12:00:00"
                    >
                    </el-date-picker>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="endTime"
                  align="center"
                  label="工程结束时间"
                >
                  <template slot-scope="scope">
                    <el-date-picker
                      :disabled="scope.row.disabled"
                      v-model="scope.row.endTime"
                      @change="blurKey"
                      type="datetime"
                      placeholder="选择工程结束时间"
                      value-format="timestamp"
                      default-time="12:00:00"
                    >
                    </el-date-picker>
                  </template>
                </el-table-column>

                <el-table-column
                  prop="workerUserId"
                  align="center"
                  label="工程师"
                >
                  <template slot-scope="scope">
                    <!-- <el-select
                      :disabled="scope.row.disabled"
                      name="propertiesType"
                      v-model="scope.row.workerUserId"
                      placeholder="请选择工程师"
                      :value="scope.row.workerUserId"
                      clearable
                      @change="blurKey"
                    >
                      <el-option
                        v-for="user in users"
                        :key="user.id"
                        :label="user.realName"
                        :value="user.id"
                      >
                      </el-option>
                    </el-select> -->
                    <el-select
                      :disabled="scope.row.disabled"
                      v-model="scope.row.workerUserId"
                      placeholder="请选择服务人员"
                      filterable
                      clearable
                      remote
                      :remote-method="remoteMethod"
                      @change="blurKey"
                    >
                      <el-option
                        v-for="user in users"
                        :key="user.id"
                        :label="user.realName"
                        :value="user.id"
                      ></el-option>
                    </el-select>
                  </template>
                </el-table-column>
              </el-table>

            </div>
          </el-form-item>
          <el-form-item
            label="备注信息"
            label-width="100px"
          >
            <div style="display: flex;width:300px;">
              <el-input
                v-model="projectServiceForm.remarks"
                placeholder="请填写工程的备注信息"
              >
              </el-input>
            </div>
          </el-form-item>
        </el-form>
        <div style='width:100%;display:flex;flex-flow:row nowrap;justify-content: center;margin-top:50px;margin-bottom:50px'>
          <el-button
            type="primary"
            size="big"
            @click="submit"
          >确定修改</el-button>
        </div>
      </div>
    </basic-container>
  </div>
</template>

<script>
import { DIC } from "@/const/dic";
import { resolveUrlPath, setUrlPath } from "@/util/util";
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
import md5 from "js-md5";
import {
  findProject,
  editAllEngineeringOrder,
  findEngineeringProjectAll,
  findEngineeringOrderById,
  findEngineeringOrderList,
  findUsersByUserTypeAll,
  findEngineeringProjectId,
  findUserList,
} from "@/api/work/projectService";

export default {
  data() {
    return {
      users: [],
      dataList: [],
      projectItems: [],
      joinsWorkServiceItems: [],
      point: {},
      fileList: [],
      tableData1: {},
      clientTypes: DIC.SERVICEITEM_TYPE,
      superiorIds: [],
      categoryTypes: [],
      currIndex: "",
      projectServiceForm: {},
      isTop: "YES",
      yyTypes: DIC.SERVICEITEM_YYTYPE,
      types: DIC.SERVICE_WARRANTY_DATE_TYPE,
      tableData: [],
      disabled: true,
    };
  },
  created() {
    // let params = {};
    // params.userType = "JOINS_ENGINEER";
    // findUsersByUserTypeAll(params).then((res) => {
    //   let data = JSON.parse(res.data);
    //   this.users = data.rows;
    //    console.log( this.users,11111);

    // });
    findEngineeringOrderById(this.$router.currentRoute.query.id).then((res) => {
      let data = JSON.parse(res.data);
      console.log(data, 1111);

      this.projectServiceForm = data;
      //回显工程项目名称
      this.projectServiceForm.projectItem = {};
      this.projectServiceForm.projectItem.id = data.serviceCategoryId;
      this.dataList = this.projectServiceForm.childList;
      console.log(this.dataList, 8888);
      let flag = 0;
      let workerUser = [];
      for (let i = 0; i < this.dataList.length; i++) {
        let obj = this.dataList[i];
        // obj.startTime=obj.serviceTime
        let userFlag = true;
        for (let k = 0; k < workerUser.length; k++) {
          if (obj.workerUserId == workerUser[k].id) {
            userFlag = false;
            break;
          }
        }
        if (userFlag) {
          if (obj.workerUserId != null && obj.workerUserId != "") {
            let user = { id: obj.workerUserId, mobile: obj.mobile };
            workerUser.push(user);
          }
        }
        console.log(
          obj.serviceTime != "" &&
            obj.serviceTime != null &&
            obj.endTime != "" &&
            obj.endTime != null &&
            obj.workerUserId != "",
          obj.serviceItemName
        );
        if (
          obj.serviceTime != "" &&
          obj.serviceTime != null &&
          obj.endTime != "" &&
          obj.endTime != null &&
          obj.workerUserId != ""
        ) {
          console.log(this.users, 7777);
          console.log(obj);

          console.log(obj.serviceItemName, "serviceItemName");
          obj.disabled = false;
        } else {
          if (flag == 0) {
            obj.disabled = false;
            flag++;
          } else {
            obj.disabled = true;
          }
        }
      }
      console.log(workerUser, "workerUser");
      for (let i = 0; i < workerUser.length; i++) {
        let params = {
          type: "JOINS_ENGINEER",
          mobile: workerUser[i].mobile,
        };
        findUserList(params).then((res) => {
          console.log(res);
          if (res.code == "200") {
            let data = JSON.parse(res.data);
            this.users.push(data[0]);
            console.log(this.users, "111111222");
          } else {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
          }
        });
      }

      // this.point.address = this.projectServiceForm.address;
      this.point.address = data.address;
      this.point.latitude = data.latitude;
      this.point.longitude = data.longitude;
    });
    findEngineeringProjectAll().then((res) => {
      let data = JSON.parse(res.data);
      this.projectItems = data;
    });
    findProject().then((res) => {
      let data = JSON.parse(res.data);
      this.superiorIds = data;
    });
  },
  methods: {
    remoteMethod(query) {
      console.log(query, 2222);
      if (query.length == 5) {
        this.users = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            console.log(res);
            if (res.code == "200") {
              let data = JSON.parse(res.data);
              console.log(data);
              this.users = data;
            } else {
              this.$message({
                showClose: true,
                message: res.message,
                type: "error",
              });
            }
          });
        }, 200);
      } else if (query.length == 11) {
        // this.loading = true;
        this.users = [];
        setTimeout(() => {
          //   this.loading = false;
          let params = {
            type: "JOINS_ENGINEER",
            mobile: query,
          };
          findUserList(params).then((res) => {
            console.log(res);
            let data = JSON.parse(res.data);
            this.users = data;
          });
        }, 200);
      } else {
        this.classifySelects = [];
      }
    },

    choseServiceItem(e) {
      console.log(e);
    },
    chooseProjectItem(e) {
      console.log(e);

      // findEngineeringProjectId(e.id).then(res => {
      //   let data = JSON.parse(res.data);
      //   console.log(data);
      //   this.dataList = data;
      // });
    },
    selectSuperiorId(e) {
      console.log(e);
      let params = {};
      params.superiorId = e;
      findProject(params).then((res) => {
        console.log(res);
        let data = JSON.parse(res.data);
        this.categoryTypes = data;
      });
    },
    selectCategory(e) {
      console.log(e);
      if (e.channel == null) {
        this.$message({
          showClose: true,
          message: e,
          type: "error",
        });
        return;
      }
      let list = e.channel.split(",");
      let obj = {};
      for (let i in list) {
        console.log(e.configs[i]);
        let dtobj = {};
        dtobj.clientType = e.configs[i].clientType;
        dtobj.agentId = e.configs[i].agentId;
        dtobj.configId = e.configs[i].id;
        dtobj.area =
          (e.configs[i].provinceName == null ? "" : e.configs[i].provinceName) +
          (e.configs[i].cityName == null ? "" : e.configs[i].cityName) +
          (e.configs[i].areaName == null ? "" : e.configs[i].areaName);
        list[i] = [];
        list[i].push(dtobj);
        obj[i] = list[i];
      }
      console.log(list);
      console.log(obj);
      this.tableData1 = obj;
    },
    isIndex(e) {
      console.log(e);
      console.log(this);
      this.currIndex = e;
    },
    handleRemove(file, fileList) {
      console.log(this);
      console.log(file, fileList);
      this.fileList = fileList;
    },
    handlePreview(file) {
      console.log(file);
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },

    submit() {
      console.log(this);
      let item = {
        close: true,
        label: "编辑工程服务",
        value: "/work/projectService/edit",
      };
      let params = {};
      console.log(this.projectServiceForm);

      params.engineeringProjectId = this.projectServiceForm.serviceCategoryId;

      params.id = this.$router.currentRoute.query.id;
      params.reservationName = this.projectServiceForm.reservationName;
      params.reservationMobile = this.projectServiceForm.reservationMobile;
      params.serviceStartTime = this.projectServiceForm.serviceTime;
      params.address = this.point.address;
      params.latitude = this.point.latitude;
      params.longitude = this.point.longitude;
      params.remarks = this.projectServiceForm.remarks;
      params.reservationChannel = "JOINS_AGENT";
      let dataList = [];
      for (let i of this.dataList) {
        console.log(i);
        let obj = {};
        obj.id = i.id;
        obj.startTime = i.serviceTime;
        obj.endTime = i.endTime;
        obj.workUserId = i.workerUserId;
        dataList.push(obj);
      }
      params.configureList = dataList;

      console.log(params);
      editAllEngineeringOrder(params).then((res) => {
        console.log(res);
        if (res.code == "200") {
          this.$message({
            showClose: true,
            message: "新增成功",
            type: "success",
          });
          if (!this.isPas) {
            this.$store.commit("DEL_TAG", item);
            let obj = {
              value: "/work/projectService",
              label: "工程服务管理",
            };
            this.$router.push({
              path: resolveUrlPath(obj.value, obj.label),
              query: obj.query,
            });
            this.isPas = true;
          }
        } else {
          if (!this.isPas) {
            this.$message({
              showClose: true,
              message: res.message,
              type: "error",
            });
            this.isPas = true;
            setTimeout(() => {
              this.isPas = false;
            }, 1000);
          }
        }
      });
    },
    handleSteppingDelete(index, row) {
      //   this.propertiesList.splice(index, 1);

      this.tableData.splice(index, 1);
    },

    blurKey() {
      console.log(this.dataList);
      let list = this.dataList;
      let flag = false;
      let count = 0;
      for (let i = 0; i < list.length; i++) {
        let obj = list[i];
        console.log(obj.endTime, "数据");
        if (
          obj.serviceTime != "" &&
          obj.serviceTime != null &&
          obj.endTime != "" &&
          obj.endTime != null &&
          obj.workerUserId != ""
        ) {
          console.log("进入");
          flag = true;
          obj.disabled = false;
          obj.serviceItemName = obj.serviceItemName + " ";
          count++;
        }
        if (i > count - 1 && flag) {
          console.log("改变" + i);
          obj.disabled = false;
          flag = false;
        }
      }

      for (let i = 0; i < list.length; i++) {
        let obj = list[i];
        if (
          obj.serviceTime == "" ||
          obj.serviceTime == null ||
          obj.endTime == "" ||
          obj.endTime == null ||
          obj.workerUserId == ""
        ) {
          if (i < list.length) {
            console.log(this.dataList[i].disabled);
            for (let j = i + 1; j < list.length; j++) {
              let obj1 = list[j];
              obj1.serviceTime = "";
              obj1.endTime = "";
              obj1.workerUserId = "";
              obj1.disabled = true;
              console.log(obj1.serviceItemName);
            }

            //return;
          }
        }
      }
      this.dataList = list;
      console.log(this.dataList, " console.log(this.dataList);");
    },

    handleAddRows(index, row) {
      console.log(index, row);
      let list = {
        yyType: "",
        id: "",
        name: "",
        amount1: "",
        amount2: "",
        amount3: "",
      };
      this.tableData.push(list);
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 8) {
        if (rowIndex % 100 === 0) {
          return {
            rowspan: 100,
            colspan: 1,
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0,
          };
        }
      }
    },
    async fnUploadDescribeImgs(option) {
      this.tableLoading = true;
      console.log(option);
      var obj = {};
      obj.name = option.file.name;
      getAliyunPublicToken().then((res) => {
        let data = JSON.parse(res.data);
        let client = new oss({
          region: data.point,
          endPoint: data.point,
          accessKeyId: data.accessKeyId,
          accessKeySecret: data.accessKeySecret,
          Expiration: data.expiration,
          bucket: data.bucketName,
          stsToken: data.securityToken,
        });
        const storeAs = md5(option.file.name) + new Date().getTime();
        client
          .multipartUpload(storeAs, option.file, {})
          .then((results) => {
            console.log(results);
            let res = results.res.requestUrls;
            let files = new Array();
            for (let url in res) {
              let file = new Object();
              file.label = storeAs;
              file.value = url;
              files.push(file);
            }
            // this.fileList = files;
            let array = results.res.requestUrls[0].split("?");
            obj.url = array[0];
            console.log(obj);
            //上传多张图片
            // if (this.tableData1[this.currIndex][0].image == undefined) {
            //   this.tableData1[this.currIndex][0].image = array[0];
            // } else {
            //   let aa = "";
            //   this.tableData1[this.currIndex][0].image = aa.concat(
            //     this.tableData1[this.currIndex][0].image,
            //     ",",
            //     array[0]
            //   );
            //   console.log(this.tableData1[this.currIndex][0].image);
            // }
            // 上传单张图片
            this.tableData1[this.currIndex][0].image = array[0];
            // this.fileList.push(obj);
            this.describeImgs.push(array[0]);
            this.tableLoading = false;
          })
          .catch((err) => {});
      });
    },
  },
};
</script>

<style>
</style>